<template>
	<q-select :value="searchWord"
			  @input="input"
			  :options="options"
			  :label="$t('label.seller')"
			  use-input
			  hide-selected
			  fill-input
			  @filter="filter"
	></q-select>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: "UserSelect",
		props: ['initialUser'],
		data() {
			return {
				searchWord: '',
				options: []
			}
		},
		mounted() {
			this.searchWord = this.initialUser ? this.initialUser.fullName : '';
			this.options = this.getOptions();
		},
		computed: {
			...mapGetters(['companyUsers']),
		},
		methods: {
			input({label, value}) {
				this.$emit('input', value);
				this.searchWord = label;
			},
			filter(val, update) {
				update(() => {
					this.options = this.getOptions(val);
				});
			},
			getOptions(sword = '') {
				const needle = sword.toLowerCase();
				return this.companyUsers.filter(user => user.fullName.toLowerCase().indexOf(needle) > -1).map(user => {
					return {label: user.fullName, value: user.uid};
				});
			}
		}
	}
</script>

<style scoped>

</style>